import React from "react";
import { FieldArray } from "formik";
import { Button, message } from "antd";
import {
  ExpressionLine,
  AddButtonArea,
  DeleteButtonArea
} from "./Styled";
import { Input } from 'formik-antd';
import {BotMessageNodeModel} from "../../../../model/workflowEditor";
import BuilderContext from "../../../context/BuilderContext";
import {useIntl} from 'react-intl';
import BaseWidgetForm from "../baseWidgetForm/BaseWidgetForm";

const { TextArea } = Input;

type BotMessageFormProps = {
  node: BotMessageNodeModel;
};

const BotMessageForm: React.FunctionComponent<BotMessageFormProps> = ({
  node
}) => {
  const { builder } = React.useContext(BuilderContext);
  const intl = useIntl();

  const onSubmit = (values: any) => {
    node.data = { messages: values.messages };
    builder?.repaint();
    message.success(intl.formatMessage({id:'workflow.node_updated_success'}));
  }

  const renderForm = (formik: any) => {
    return  <FieldArray
    name="messages"
    render={arrayHelpers => (
      <div>
        {
          formik.values.messages?.map((message: any, index: number) => (
            <ExpressionLine key={index}>
              <TextArea
                value={message}
                name={`messages.${index}`}
              />
              <DeleteButtonArea>
                <Button
                  danger
                  onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                >
                  -
                </Button>
              </DeleteButtonArea>
            </ExpressionLine>
          ))
        }
        <AddButtonArea>
          <Button
            onClick={() => arrayHelpers.push("")} // insert an empty string at a position
          >
            +
          </Button>
        </AddButtonArea>
      </div>
    )}
  />
  }

  return(
    <BaseWidgetForm
      title='BOT REPLY'
      initialValues={{ messages: node.data.messages }}
      onSubmit={onSubmit}
      renderForm={renderForm}
    />
)};

export default BotMessageForm;